<template>
  <div class="exercise-test">
    <div class="view-test-group">
      <div class="view-test flex justify-end">
        <div 
          :class="`w-11/12 cursor-pointer p-4 border rounded border-grey-light test-content ${test.is_hidden ? 'border-dashed' : 'border-solid'}`"
          @click.stop="onEdit(test)"
        >
          <prism :language="exercise.language">{{ test.code }}</prism>
        </div>
        <div class="p-4 cursor-pointer delete-test" @click.stop="$emit('delete-test', {testId: test.id})" title="Delete test"><feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 color-current text-danger"/></div>
      </div>
    </div>
  </div>
</template>
<script>
import Prism from 'vue-prism-component'

export default {
  components: {
    Prism
  },
  props: {
    exercise: Object,
    test: Object,
    onEdit: Function
  },
}
</script>
<style lang="scss">
  .exercise-test {
    .delete-test {
      height: 45px;
    }
  }
</style>